import type { NilDealResponse } from '@on3/api';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { Text } from 'components/UI/Typography/Text';
import { useCallback } from 'react';

import styles from './GroupDealItem.module.scss';

interface IDealResponse {
  item?: NilDealResponse;
}

export const GroupDealItem = ({ item }: IDealResponse) => {
  const { organization, positions, sports } = item || {};
  const showPosition = useCallback((value: any[]) => {
    if (value?.length === 1) {
      return value[0].abbreviation;
    } else if (value?.length > 1) {
      return 'Multiple Positions';
    }

    return;
  }, []);
  const showSport = sports?.length === 1 ? sports[0]?.name : 'Multiple Sports';

  return (
    <div className={styles.groupDealWrapper}>
      <TeamAvatar
        className={styles.teamLogo}
        height={60}
        slug={organization?.slug}
        src={organization?.assetUrl}
        width={60}
      />

      <Text className={styles.teamName} variant="h5">
        {organization?.fullName}
      </Text>
      <div className={styles.sportWrapper}>
        {!!sports?.length && (
          <Text className={styles.sport} variant="subtitle1">
            {showSport}
          </Text>
        )}

        {!!positions?.length && (
          <Text className={styles.position} variant="subtitle1">
            {showPosition(positions)}
          </Text>
        )}
      </div>
    </div>
  );
};
